// extracted by mini-css-extract-plugin
export default {"button":"InfoButton_button__Fn8Qh"};